module.exports = __webpack_public_path__ + "media/images/meta/xponential/favicon-462c851b5ff789a8661bd68640d56de5.png";